import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch } from '../../hooks/hooks';
import { addBreadcrumbTextReplacement } from '../../store/appSlice';
import StickyHeader, { type StickyHeaderConfig } from '../dashboardHeader/StickyHeader';

interface PageProps {
  children: React.ReactNode;
  title?: string;
  stickyHeader?: React.ReactNode;
  padStickyHeader?: boolean;
  targetScrollProgress?: number;
}

export default function Page(props: PageProps) {
  const dispatch = useAppDispatch();
  const location = useLocation();

  useEffect(() => {
    if (props.title) {
      dispatch(addBreadcrumbTextReplacement([location.pathname.split('/').pop(), props.title]));
    }
  }, [props.title]);

  const stickyHeaderConfig: StickyHeaderConfig | undefined =
    props.stickyHeader && props.targetScrollProgress !== undefined
      ? {
          content: props.stickyHeader,
          targetScrollProgress: props.targetScrollProgress,
          pad: props.padStickyHeader
        }
      : undefined;

  return (
    <div className={'xd-page flex flex-col w-full flex-1 min-h-0 overflow-hidden'}>
      <div>{props.children}</div>
      {stickyHeaderConfig ? <StickyHeader config={stickyHeaderConfig} /> : null}
    </div>
  );
}
